import { parseJsonText } from "typescript";
import { RTABAK_URLS } from "../utils/urls";
import request from "./request";

type carouselParams = {
  name?: string;
};

type carouselUpdateParams = {
  name: string;
  products: {
    order: number;
    productId: string;
  }[];
};

const carouselServices = {
  getCarousels: async (params?: carouselParams): Promise<any> => {
    return await request({
      method: "get",
      baseURL: RTABAK_URLS.API.Carousels,
    });
  },
  getCarouselByName: async (params: carouselParams): Promise<any> => {
    return await request({
      method: "get",
      baseURL: RTABAK_URLS.API.Carousels + "/" + params.name,
    });
  },
};

export { carouselServices };
